import React, { useState, useEffect } from 'react';
import logo from '../assets/imagesLand/logo.png';
import { Menu, X } from 'lucide-react';
import { FaCartShopping } from "react-icons/fa6";
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../src/redux/hook';
import { getTotalAmount } from '../../src/redux/slice/useCartSlice';

const NAV_LINKS = [
  { href: 'fonctionnalites', label: 'Fonctionnalités' },
  { href: 'pricing',         label: 'Tarifs'          },
  { href: 'equipements',     label: 'Equipements'     },
  { href: 'temoignages',     label: 'Témoignages'     },
  { href: 'faq',             label: 'FAQ'             },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate  = useNavigate();
  const location  = useLocation();

  const dispatch = useAppDispatch();
  const { cartItems } = useAppSelector((state) => state.cart);

  useEffect(() => {
    dispatch(getTotalAmount());
  }, [cartItems]);

  // Gère le clic sur un lien de section
  const handleNavClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    sectionId: string
  ) => {
    e.preventDefault();
    setMobileOpen(false);

    const isOnHome = location.pathname === '/';

    if (isOnHome) {
      
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      
      navigate('/');
      
      setTimeout(() => {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  };

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-[100] bg-[#053965] border-b border-white/[0.08]">

        <div className="max-w-[1200px] mx-auto px-6 h-[60px] flex items-center justify-between gap-6">

          {/* Logo */}
          <a href="/" className="flex items-center shrink-0  imageLogo">
            <img src={logo} alt="logo" className="h-[36px]" />
          </a>

          {/* Menu desktop */}
          <ul className="hidden md:flex gap-2 items-center flex-1 justify-center list-none menu-lang  ">
            {NAV_LINKS.map(link => (
              <li key={link.href}>
                
                <a  href={`/#${link.href}`}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="px-[16px] py-[6px] rounded-md text-[16px] leading-[65px] text-white text-center no-underline transition-all whitespace-nowrap font-[Montserrat] navb font-bold"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          {/* Right */}
          <div className="flex items-center gap-5 shrink-0  ">

            {/* Panier — visible partout */}
            <NavLink
              to="/panier"
              className="relative text-white hover:text-[#FFA800] transition-colors panier-hamb"
              aria-label="Panier"
            >
              <FaCartShopping size={24} />
              <span className="absolute -top-1.5 -right-1.5 bg-[#F59E0B] text-white rounded-full w-[16px] h-[16px] text-[9px] font-bold flex items-center justify-center leading-none">
                {cartItems?.length ?? 0}
              </span>
            </NavLink>

            {/* Bouton Demo — desktop seulement */}
            
           <button
  onClick={() => handleNavClick({ preventDefault: () => {} } as any, 'contact')}
  className="hidden md:flex items-center justify-center bg-[#FFA800] rounded-full px-[40px] py-[8px] w-[240px] hover:bg-[#e69600] hover:scale-105 transition-all duration-200 btn-demo border-none cursor-pointer"
>
  <span className="text-white text-[14px] font-bold whitespace-nowrap">Demo gratuite</span>
</button>

            {/* Hamburger */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="flex md:hidden w-10 h-10 rounded-md bg-white/10 border-none items-center justify-center text-white cursor-pointer"
            >
              {mobileOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        <div className={`bg-[#053965] flex flex-col px-5 overflow-hidden transition-all duration-300 ease-in-out ${
          mobileOpen ? 'max-h-[420px] py-4 border-t border-white/10' : 'max-h-0 py-0'
        }`}>
          {NAV_LINKS.map(link => (
            
            <a  key={link.href}
              href={`/#${link.href}`}
              onClick={(e) => handleNavClick(e, link.href)}
              className="px-3 py-3 font-bold rounded-lg no-underline text-white/85 text-[16px] font-medium hover:bg-white/10 hover:text-white transition-all"
            >
              {link.label}
            </a>
          ))}

          
         <button
  onClick={() => handleNavClick({ preventDefault: () => {} } as any, 'contact')}
  className="mt-2 inline-flex items-center justify-center bg-[#FFA800] rounded-full py-2 px-4 hover:bg-[#e69600] transition-all border-none cursor-pointer"
>
  <span className="text-white text-[14px] font-bold">Demo gratuite</span>
</button>
        </div>
      </nav>
    </>
  );
}